/* eslint-disable max-lines-per-function */
import { Button, Label, Skeleton } from '@e2n/ui';
import { AvatarBox } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/AvatarBox';
import { useFristenContext } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/context/useFristenContext';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { FristenGrund } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/fristenGrund';
import { cn } from '@/lib/utils';
import { faPenToSquare, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

export function FristenMobile({ readonly = false }: { readonly?: boolean }) {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { setFristIndex, setOpenEditSheet, setOpenDeleteDialog } =
    useFristenContext();

  return (
    <form.Subscribe
      selector={(state) => state.values.anstellungsverhaeltnis.fristen}>
      {(fristen) =>
        fristen.length > 0 && (
          <div className="flex flex-col gap-4 md:hidden py-6 w-full">
            {fristen.map((frist, index) => (
              <div
                key={index}
                className="grid grid-cols-2 border-b border-neutrals-300 pb-4 gap-4">
                <div className="flex flex-col gap-1">
                  <Label className="text-neutrals-700 text-sm font-semibold leading-4">
                    {' '}
                    {t(
                      'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.fristdatum.label',
                    )}
                  </Label>
                  <span className="text-neutrals-900 text-sm font-semibold leading-5">
                    {dayjs(frist.fristdatum).format('DD.MM.YYYY')}
                  </span>
                </div>
                <div className="flex flex-col gap-1">
                  <Label className="text-neutrals-700 text-sm font-semibold leading-4">
                    {' '}
                    {t(
                      'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.grund.label',
                    )}
                  </Label>
                  <span className="text-neutrals-900 text-sm font-semibold leading-5 wrap-anywhere">
                    {frist.grund === FristenGrund.ANDERER
                      ? frist.andererGrund
                      : t(
                          `domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.grund.options.${frist.grund}`,
                        )}
                  </span>
                </div>

                <div className="flex flex-col gap-1">
                  <Label className="text-neutrals-700 text-sm font-semibold leading-4">
                    {' '}
                    {t('domain.mitarbeiter.fristen.erinnerungsZeit.label')}
                  </Label>
                  <span className="text-neutrals-900 text-sm font-semibold leading-5">
                    {frist.erinnerungsZeit
                      .map((zeit) =>
                        t(
                          `domain.mitarbeiter.fristen.erinnerungsZeit.options.${zeit}`,
                        ),
                      )
                      .join(', ')}
                  </span>
                </div>
                <div className="flex flex-col gap-1">
                  <Label className="text-neutrals-700 text-sm font-semibold leading-4">
                    {' '}
                    {t(
                      'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.erinnerungAn.label',
                    )}
                  </Label>
                  <Suspense fallback={<Skeleton className="h-8 w-full" />}>
                    <AvatarBox managerIds={frist.erinnerungAn} />
                  </Suspense>
                </div>

                <div className="flex flex-col gap-1 col-span-2">
                  <Label className="text-neutrals-700 text-sm font-semibold leading-4">
                    {' '}
                    {t(
                      'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.bemerkung.label',
                    )}
                  </Label>
                  <span className="text-neutrals-900 text-sm font-semibold leading-5">
                    {frist.bemerkung || '-'}
                  </span>
                </div>
                <div
                  className={cn('flex gap-2 col-span-2', readonly && 'hidden')}>
                  <Button
                    variant={'icon'}
                    onClick={() => {
                      setFristIndex(index);
                      setOpenEditSheet(true);
                    }}>
                    <FontAwesomeIcon
                      icon={faPenToSquare}
                      className="text-primary-blue-600"
                    />
                  </Button>
                  <Button
                    variant={'icon'}
                    onClick={() => {
                      setFristIndex(index);
                      setOpenDeleteDialog(true);
                    }}>
                    <FontAwesomeIcon
                      icon={faTrashCan}
                      className="text-primary-red-600"
                    />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )
      }
    </form.Subscribe>
  );
}
